import { translate } from 'sulu-admin-bundle/utils';
import { AbstractFormToolbarAction } from 'sulu-admin-bundle/views';
import React from 'react';
import Dialog from 'sulu-admin-bundle/components/Dialog';
import { action, observable } from 'mobx';

export default class NewsNotificationToolbarAction extends AbstractFormToolbarAction {
    @observable toolbarItemDisabled = false;
    @observable showOverlay = false;

    getToolbarItemConfig() {
        const { dirty, saving } = this.resourceFormStore;

        return {
            type: 'button',
            label: translate('app.notification'),
            icon: 'su-envelope',
            onClick: action(() => {
                this.showOverlay = true;
            }),
            disabled: dirty || saving || this.toolbarItemDisabled,
        };
    }

    /**
     * Returns the Dialog component.
     * This is an overlay with a text, where the user has the possibility to accept or decline.
     *
     * @return {JSX.Element}
     */
    getNode() {
        return (
            <Dialog
                cancelText={ translate('sulu_admin.cancel') }
                confirmLoading={ false }
                confirmText={ translate('sulu_admin.ok') }
                key={ 'sulu_admin.send_notification' + this.options.formKey }
                onCancel={ this.handleClose }
                onConfirm={ this.handleConfirm }
                open={ this.showOverlay }
                title={ translate('app.notification') }
            >
                <p>{ translate('app.notification_warning') }</p>
            </Dialog>
        );
    }

    /**
     * Called after the user has clicked on the confirmation button in the overlay.
     * This will call an API (in the "App/Controller/Admin/NewsController") which will send email notifications.
     */
    handleConfirm = () => {
        const formData = this.resourceFormStore.data;
        const locale = this.resourceFormStore.locale.get();

        fetch('/admin/api/news-notification?locale=' + locale, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(() => {
                this.handleClose();
                this.form.showSuccessSnackbar();
                this.disableToolbarItem();
            });
    };

    @action disableToolbarItem = () => {
        this.toolbarItemDisabled = true;
    };

    @action handleClose = () => {
        this.showOverlay = false;
    };
}
